import { useRef, useEffect } from 'react';
import { exportLayout, applyLayout } from '../lib/utils';
import { useSetRecoilState, useRecoilValue, useRecoilState, useRecoilCallback } from 'recoil';
import set from 'lodash/fp/set';
import * as atoms from './atoms';
export function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
export function useGraph() {
    var graph = useRecoilValue(atoms.graph);
    return graph;
}
export function useRenderer() {
    return useRecoilState(atoms.renderer);
}
export function useModel() {
    var model = useRecoilValue(atoms.model);
    return model;
}
export function useToolBoxState() {
    var _a = useRecoilState(atoms.toolBoxState), toolBoxState = _a[0], setToolBoxState = _a[1];
    return [
        toolBoxState,
        {
            setNodeColor: function (nodeColor) {
                return setToolBoxState(set(['variables', 'nodes', 'color'], nodeColor));
            },
            setNodeSize: function (nodeSize) {
                return setToolBoxState(set(['variables', 'nodes', 'size'], nodeSize));
            },
            setNodeLabel: function (nodeLabel) {
                return setToolBoxState(set(['variables', 'labels', 'text'], nodeLabel));
            },
            setLabelDensity: function (density) {
                return setToolBoxState(set(['variables', 'labels', 'density'], density));
            },
            setEdgeColor: function (edgeColor) {
                return setToolBoxState(set(['variables', 'edges', 'color'], edgeColor));
            },
            setEdgeSize: function (edgeSize) {
                return setToolBoxState(set(['variables', 'edges', 'size'], edgeSize));
            }
        }
    ];
}
export function useGraphVariables() {
    var variables = useRecoilValue(atoms.graphVariables);
    return variables;
}
export function useSetNewGraph() {
    return useRecoilCallback(function (_a) {
        var set = _a.set;
        return function (graph, model) {
            // Initializing toolbox state
            var toolBoxState = {
                variables: {
                    nodes: {
                        color: model.defaultNodeColor,
                        size: model.defaultNodeSize
                    },
                    edges: {
                        color: model.defaultEdgeColor,
                        size: model.defaultEdgeSize
                    },
                    labels: {
                        text: model.defaultNodeLabel,
                        density: 1
                    }
                }
            };
            // Batch updates
            set(atoms.view, 'basemap');
            set(atoms.modal, null);
            set(atoms.graph, graph);
            set(atoms.model, model);
            set(atoms.toolBoxState, toolBoxState);
            set(atoms.collaterals, {
                initialLayout: exportLayout(graph)
            });
        };
    }, []);
}
export function useResetLayout() {
    var collaterals = useRecoilValue(atoms.collaterals);
    var graph = useRecoilValue(atoms.graph);
    var renderer = useRecoilValue(atoms.renderer);
    return function () {
        if (!collaterals)
            return;
        applyLayout(graph, collaterals.initialLayout);
        // TODO: drop this later when batch updates are supported in sigma
        renderer.refresh();
    };
}
export function useOpenModal() {
    var setModal = useSetRecoilState(atoms.modal);
    return setModal;
}
export function useCloseModal() {
    var setModal = useSetRecoilState(atoms.modal);
    return function () { return setModal(null); };
}
export function useIsPreloadingGraph() {
    return useRecoilState(atoms.isPreloadingGraph);
}
export function useCanvas(callback, deps) {
    if (deps === void 0) { deps = []; }
    var canvasRef = useRef(null);
    useEffect(function () {
        var canvas = canvasRef.current;
        var ctx = canvas.getContext('2d');
        callback(canvas, ctx);
    }, deps);
    return canvasRef;
}
